import { adminGet, adminPatch, adminPost } from "@lib/adminApi";
import type { Product } from "@pages/ProductCatalog/store";

// omg-api admin product catalog (OMG-2091), replacing the legacy GraphQL
// listProducts / getProduct / createProduct / updateProduct. The API exposes
// the native shape: one pricing row per country, no localizations.

// One pricing row (per country). `promotionSlug` is round-tripped by the UI but
// not edited; `active` gates checkout (replace-all resurrects an omitted row as
// active, so it must be sent explicitly).
export type PricingInput = {
  amount: number;
  strikeThroughAmount: number;
  currency: string;
  countryCode: string;
  startDate?: string | null;
  endDate?: string | null;
  promotionSlug?: string | null;
  active?: boolean;
};

export type CreateProductInput = {
  name: string;
  slug?: string;
  displayName?: string;
  entitlements?: string[];
  pricings?: PricingInput[];
};

// `name` is the checkout SKU and is intentionally not patchable.
export type UpdateProductInput = {
  slug?: string;
  displayName?: string;
  active?: boolean;
  entitlements?: string[];
  pricings?: PricingInput[];
};

export const listProducts = (): Promise<Product[]> =>
  adminGet<Product[]>("/admin/products");

export const getProduct = (id: number): Promise<Product> =>
  adminGet<Product>(`/admin/products/${id}`);

export const createProduct = (body: CreateProductInput): Promise<Product> =>
  adminPost<Product>("/admin/products", body);

export const updateProduct = (
  id: number,
  body: UpdateProductInput,
): Promise<Product> => adminPatch<Product>(`/admin/products/${id}`, body);
